var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Les meves incidències")]),_c('AddTicket'),(this.user_tickets)?_c('UserTicketsTable',{attrs:{"table_rows":this.user_tickets,"states":_vm.states}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }